import { Box } from '@breathelife/mui';
import styled from '../Styles/themed-styled-components';

export const RequiredAuthErrorContainer = styled(Box)`
  background-color: ${(props) => props.theme.colors.grey[10]};
  border-radius: 3px;
  max-width: 380px;
  width: 100%;
`;
